import React from 'react'
import PropTypes from 'prop-types'

const DisplayCollection = ({ hasResults, noResultsMessage, children }) => {
  return hasResults ? children : noResultsMessage
}

DisplayCollection.defaultProps = {
  noResultsMessage: <p>No results found</p>,
}

DisplayCollection.propTypes = {
  hasResults: PropTypes.bool.isRequired,
  noResultsMessage: PropTypes.node,
  children: PropTypes.node,
}

export default DisplayCollection
